module.exports = __webpack_public_path__ + "static/media/capacity-collaboration.b04d6a34.jpg";